import React, { useState } from 'react';
import './search-condition.css';
import OccurrenceSourceComponent from './components/OccurrenceSourceComponent';
import UserComponent from './components/UserComponent';
import ArbitraryCharacterComponent from './components/ArbitraryCharacterComponent';
import DateComponent from './components/DateComponent';
import MessageTypeComponent from './components/MessageTypeComponent';
import CentumTabs from '../../../../Tabs/CentumTab';
import CentumButton from '../../../../Button/CentumButton';
import CentumInput from '../../../../Input/CentumInput';
import { number } from 'echarts';
import { Config } from './searchConditionInterface';

interface ISearchCondition {
    config: Config;
    CloseSearchCondition: () => void;
    handleSearch: (config: Config) => void;
}

export interface tabComponents {
    tempConfig: Config;
    SaveConfig: (conf: Config) => void;
}

function SearchCondition(props: ISearchCondition) {
    const { config, CloseSearchCondition } = props;
    const tabGroups = [
        {
            title: 'Group 1',
            tabs: [{ title: 'Occurrence Source' }, { title: 'User' }, { title: 'Arbitrary Character' }]
        },
        {
            title: 'Group 2',
            tabs: [{ title: 'Date' }, { title: 'Message Type' }]
        }
    ];

    type TabKey = keyof typeof tabComponents;
    const [selectedTab, setSelectedTab] = React.useState<TabKey | ''>('Date');
    const [tempConfig, setTempConfig] = useState<Config>(config);

    function CloseSearch() {
        CloseSearchCondition();
    }

    const SelectDirection = (mode: string) => {
        const updateConf = { ...tempConfig };
        updateConf.direction.select(mode);
        setTempConfig(updateConf);
    };

    const SelectDisplay = (event: string) => {
        const updateConf = { ...tempConfig };
        updateConf.display.select(event);
        setTempConfig(updateConf);
    };

    const SaveConfig = (conf: Config) => {
        setTempConfig(conf);
    };

    const tabComponents = {
        'Occurrence Source': <OccurrenceSourceComponent tempConfig={tempConfig} SaveConfig={SaveConfig} />,
        User: <UserComponent tempConfig={tempConfig} SaveConfig={SaveConfig} />,
        'Arbitrary Character': <ArbitraryCharacterComponent tempConfig={tempConfig} SaveConfig={SaveConfig} />,
        Date: <DateComponent tempConfig={tempConfig} SaveConfig={SaveConfig} />,
        'Message Type': <MessageTypeComponent tempConfig={tempConfig} SaveConfig={SaveConfig} />
    };

    return (
        <div style={{ display: 'flex', width: '100%', height: '100%' }}>
            <div className="left-menu-container">
                <div style={{ padding: '0px 5px' }}>
                    <CentumTabs
                        tabGroups={tabGroups}
                        selectedTab={(title: string) => {
                            setSelectedTab(title as TabKey);
                        }}
                    />
                </div>

                {selectedTab ? <div className="left-menu">{tabComponents[selectedTab]}</div> : <></>}
                <div className="buttons-container">
                    <CentumButton
                        name={'Search'}
                        onClick={() => {
                            props.handleSearch(tempConfig);
                            CloseSearch();
                        }}
                        style={{ height: '25px', width: '80px' }}
                    />
                    <CentumButton
                        name={'Cancel'}
                        onClick={() => CloseSearch()}
                        style={{ height: '25px', width: '80px' }}
                    />
                </div>
            </div>
            <div className="right-menu-container">
                <div className="direction">
                    <div>
                        <CentumInput
                            type="radio"
                            id="Backward"
                            checked={tempConfig.direction.backward}
                            onChange={() => SelectDirection('backward')}
                        />
                        Backward
                    </div>
                    <div>
                        <CentumInput
                            type="radio"
                            id="Forward"
                            checked={tempConfig.direction.forward}
                            onChange={() => SelectDirection('forward')}
                        />
                        Forward
                    </div>
                </div>
                <div className="display">
                    <div>
                        <CentumInput
                            type="radio"
                            id="All"
                            checked={tempConfig.display.all}
                            onChange={() => SelectDisplay('all')}
                        />
                        All
                    </div>
                    <div>
                        <CentumInput
                            type="radio"
                            id="Search"
                            checked={tempConfig.display.search}
                            onChange={() => SelectDisplay('search')}
                        />
                        Search
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SearchCondition;
